import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import ConfirmDeleteModal from './ConfirmationModelDelete';
import './List.css'; // Import the CSS file

// Static data for delivery boys
const staticUserData = [
  {
    id: 1,
    storeName: "Store A",
    ownerName: "John Doe",
    email: "john@example.com",
    contactNo: "123-456-7890",
    address: "123 Main St, City, Country",
    websiteURL: "http://storea.com",
    storeLogo: "https://via.placeholder.com/50",
    storeBannerImage: "https://via.placeholder.com/150",
    createdAt: "2024-08-29T10:00:00Z"
  },
  {
    id: 2,
    storeName: "Store B",
    ownerName: "Jane Smith",
    email: "jane@example.com",
    contactNo: "987-654-3210",
    address: "456 Elm St, City, Country",
    websiteURL: "http://storeb.com",
    storeLogo: "https://via.placeholder.com/50",
    storeBannerImage: "https://via.placeholder.com/150",
    createdAt: "2024-08-28T12:00:00Z"
  },
  // Add more static data as needed
];

const ListMerchant = () => {
  const [userData, setUserData] = useState(staticUserData);
  const [filteredData, setFilteredData] = useState(staticUserData);
  const [searchOwnerName, setSearchOwnerName] = useState("");
  const [searchShopName, setSearchShopName] = useState("");
  const [searchContactNo, setSearchContactNo] = useState("");
  const [searchEmail, setSearchEmail] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const history = useHistory();

  const handleEdit = (e, id) => {
    history.push(`/editDeliveryboy/${id}`);
  };

  const handleDelete = (id) => {
    // Simulate deleting a user
    setUserData(prevData => prevData.filter(user => user.id !== id));
    setFilteredData(prevData => prevData.filter(user => user.id !== id));
    setShowModal(false);
  };

  const handleDeleteClick = (id) => {
    setSelectedUserId(id);
    setShowModal(true);
  };

  useEffect(() => {
    filterData();
  }, [searchOwnerName, searchShopName, searchContactNo, searchEmail]);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const filterData = () => {
    const filtered = userData.filter(user =>
      user.ownerName.toLowerCase().includes(searchOwnerName.toLowerCase()) &&
      user.storeName.toLowerCase().includes(searchShopName.toLowerCase()) &&
      user.contactNo.includes(searchContactNo) &&
      user.email.toLowerCase().includes(searchEmail.toLowerCase())
    );
    setFilteredData(filtered);
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>List Merchant</h2>
        </div>
        <div className="body">
          <div className="search-filters">
            <input
              type="text"
              placeholder="Search Owner Name"
              value={searchOwnerName}
              onChange={(e) => setSearchOwnerName(e.target.value)}
              className="search-input"
            />
            <input
              type="text"
              placeholder="Search Shop Name"
              value={searchShopName}
              onChange={(e) => setSearchShopName(e.target.value)}
              className="search-input"
            />
            <input
              type="text"
              placeholder="Search Contact No"
              value={searchContactNo}
              onChange={(e) => setSearchContactNo(e.target.value)}
              className="search-input"
            />
            <input
              type="text"
              placeholder="Search Email"
              value={searchEmail}
              onChange={(e) => setSearchEmail(e.target.value)}
              className="search-input"
            />
          </div>
          <div className="table-responsive">
            <table className="table table-hover">
              <thead style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                <tr>
                  <th>#</th>
                  <th>Store Name</th>
                  <th>Owner Name</th>
                  <th>Contact Email</th>
                  <th>Contact Phone</th>
                  <th>Store Address</th>
                  <th>Website URL</th>
                  <th>Store Logo</th>
                  <th>Store Banner Image</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody style={{ textAlign: "center" }}>
                {filteredData.map((user, index) => (
                  <tr key={user.id}>
                    <td>{index + 1}</td>
                    <td>{user.storeName}</td>
                    <td>{user.ownerName}</td>
                    <td>{user.email}</td>
                    <td>{user.contactNo}</td>
                    <td>{user.address}</td>
                    <td>{user.websiteURL}</td>
                    <td><img src={user.storeLogo} alt="Store Logo" width="50" /></td>
                    <td><img src={user.storeBannerImage} alt="Store Banner" width="50" /></td>
                    <td>{formatDate(user.createdAt)}</td>
                    <td>
                      <i className="icon-pencil" onClick={(e) => handleEdit(e, user.id)}></i>
                      &nbsp;&nbsp;
                      <i className="fa fa-trash-o" onClick={() => handleDeleteClick(user.id)}></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <ConfirmDeleteModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          handleConfirm={() => handleDelete(selectedUserId)}
        />
      </div>
    </div>
  );
};

export default ListMerchant;
